module.exports = __webpack_public_path__ + "static/logow-32ea430b9f59c0615bbab3b3248a2be2.svg";